import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { Link, useHistory } from "react-router-dom";
import flag from "../../../../../../assets/images/flag.png";
import clock from "../../../../../../assets/images/meetupEvent/clock.png";

import flag4 from "../../../../../../assets/images/Interval-01.1.png";
import flag2 from "../../../../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../../../../assets/images/Minimum-Time-01.1.png";

import { useContext } from "react";
import Countdown from 'react-countdown';
import ContdownTimerRender from "../../../../../../HelperComponent/ContdownTimerRender";
import { serverInfo } from "../../../../../../App";

const CompletedMeetup = (props) => {

  const history = useHistory();
  const { imageCdnUrl } = useContext(serverInfo);

  const [event, setEvent] = useState("");
  const [eventTime, setEventTime] = useState();


  useEffect(() => {
    let isMounted = true;

    const event_id = props.match.params.id;

    axios.get(`/api/admin/meetup_event/details/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setEvent(res.data.meetup);
          setEventTime(res.data.meetup?.event_date);
          if (res.data.meetup?.status > 1) {
            history.push(
              `/superstar-admin/meetup-events/details/${event_id}`
            );
          }
        }
      }
    });
  }, [props.match.params.slug, history]);

 
  const startTime = moment(eventTime).format("LL") + " " + event.start_time;

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
            <div className="card card-bg p-3 me-2">
              <img
                src={imageCdnUrl + event.banner}
                alt=""
                className="img-fluid Banner-SME-b "
              />
    
              <Countdown
              date={startTime}
              renderer={ContdownTimerRender}
            />
          </div>
       </div>
          <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
            <div className="registration-head  card-bg mb-1">
              <h5 className="text-warning fw-bold p-2">Registration </h5>
            </div>

            <div className="row registration-body  card-bg m-0 pt-3">
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Registration Start:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.reg_start_date).format("LL")}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Registration End:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.reg_end_date).format("LL")}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag2} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Type:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {event.meetup_type}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag3} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Total Seat: </span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {event.total_seat}
                    </span>
                  </div>
                </div>
              </div>

              {event.meetup_type === "Offline" ? (
                <div className="col-md-12 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag4} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Venue: </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.venue}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-md-12">
            <div className="card card-bg shadow">
              <div className="card-body">
                <h5 className="text-light pb-3">
                  {event.title} &nbsp;
                  <sub className="text-warning">({event.meetup_type})</sub>
                </h5>

                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.instruction} />
                </p>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={event.description} />
                </p>

                <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                  <h5 className="text-warning pt-2 ">Event Date</h5>
                  <p className="text-light fw-bold pt-2">
                    {moment(event.event_date).format("LL")} |{" "}
                    {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                    {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card card-bg my-4">
          <div className="row">
            <div className="col-md-4 d-flex justify-content-center align-items-center">
              <img src={clock} className="img-fluid p-3" alt="" />
            </div>
            <div className="col-md-4 d-flex align-items-center">
              <div className="mx-3">
                <h2 className="text-warning">Event Details submitted</h2>
                <p className="text-light">
                  Waiting for &nbsp;
                  {Number(event.status) === 1 ? (
                    <span className="fw-bold">Manager Admin</span>
                  ) : (
                    <span className="fw-bold">SuperStar</span>
                  )}
                  &nbsp; Approval
                </p>
                {Number(event.status) < 1 ? (
                  <p>
                    <Link
                      to={`/superstar-admin/meetup-events/edit/${event.id}`}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <button className="btn btnEditTest w-100 fw-bold px-4">
                            Edit
                          </button>
                        </div>
                      </div>
                    </Link>
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div
              className="col-md-4"
              style={{ borderLeft: "1px dashed yellow" }}
            >
              <h5 className="text-light text-center my-3">Status</h5>
              <div className="d-flex justify-content-center align-items-center ">
                <div style={{ width: 150, height: 150 }}>
                  {Number(event.status) === 1 ? (
                    <CircularProgressbarWithChildren
                      value={50}
                      styles={buildStyles({ pathColor: `gold` })}
                    >
                      {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                      <div style={{ fontSize: 12, marginTop: -5 }}>
                        <strong className="text-light">50% complete</strong>
                      </div>
                    </CircularProgressbarWithChildren>
                  ) : (
                    <CircularProgressbarWithChildren
                      value={0}
                      styles={buildStyles({ pathColor: `gold` })}
                    >
                      {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                      <div style={{ fontSize: 12, marginTop: -5 }}>
                        <strong className="text-light">0% complete</strong>
                      </div>
                    </CircularProgressbarWithChildren>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompletedMeetup;
